class FreeShippingBar {
  constructor() {
    this.freeShippingThreshold = 24900; // R$249,00 em centavos
    this.setupEventListeners();
    this.updateFreeShippingBar();
  }

  setupEventListeners() {
    // Atualiza a barra quando o carrinho é atualizado
    subscribe(PUB_SUB_EVENTS.cartUpdate, () => {
      this.updateFreeShippingBar();
    });
  }

  updateFreeShippingBar() {
    const progressBar = document.getElementById('frete-progress-bar');
    const messageElement = document.querySelector('.free-shipping-text');
    
    if (!progressBar || !messageElement) return;
    
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price;
        const remaining = this.freeShippingThreshold - cartTotal;
        const progressPercentage = Math.min((cartTotal / this.freeShippingThreshold) * 100, 100);
        
        progressBar.value = progressPercentage;
        
        if (remaining > 0) {
          const formattedRemaining = new Intl.NumberFormat('pt-BR', {
            style: 'currency',
            currency: 'BRL'
          }).format(remaining / 100);

          messageElement.innerHTML = `Faltam <span class="special-text">${formattedRemaining}</span> para frete grátis!`;
        } else {
          messageElement.textContent = `🚚 EBA! FRETE GRÁTIS GARANTIDO! 🚚`
        }
      })
      .catch(error => console.error('Erro ao atualizar barra de frete grátis:', error));
  }
}


document.addEventListener('DOMContentLoaded', () => {
  window.freeShippingBar = new FreeShippingBar();
});